// Core
import './core/globalState';
import './core/appConfig';
import './core/componentRegistry';

// Utils
import './utils/inputStyles';
import './utils/citySelect';
import './utils/inputHelpers';

// Services
import './services/cartService';
import './services/favoriteService';
import './services/subscribeService';
import './services/userService';
import './services/productService';
import './services/serviceService';
import './services/specialistService';
import './services/faqService';
import './services/reviewService';
import './services/departmentService';
import './services/serviceGroupsService';
import './services/specialistsPageService';
import './services/servicesPageService';
import './services/recordPageService';
import './services/recordPageService';


// Components
import './components/modals';
import './components/header';
import './components/footer';

// Sections
import './components/sections/catalog-vertical-simple';
import './components/sections/catalog-services';
import './components/sections/catalog-specialist-child';
import './components/sections/catalog-specialist';
import './components/sections/faq';
import './components/sections/faqChild';
import './components/sections/brands-preview';
import './components/sections/articles-preview';
import './components/sections/reviews';
import './components/sections/department';
import './components/sections/service-groups';
import './components/sections/specialists';
import './components/sections/services-page';
import './components/sections/service-groups-block';
import './components/sections/service-groups-child-block';
import './components/sections/contract';
import './components/sections/questions';
import './components/sections/services-tabs';

// Pages
import './components/pages/articles';
import './components/pages/record';
import './components/pages/programs';
import './components/pages/program';




// Инициализация
document.addEventListener('DOMContentLoaded', function() {
    // Инициализация стилей инпутов
    window.initInputStyles();

    // Автоматическая регистрация и монтирование компонентов
    const registry = new ComponentRegistry();
    registry.mountAll();
});